import { Box, Grid2, Stack, Typography, useTheme } from "@mui/material";
import EthiquinNoData from "../../../../../assets/images/Ethiquin/ethiquin_no_data.svg";
import { useTranslation } from "react-i18next";

export const InvestigationAdvertisement = ({ title, description }) => {
  const [t] = useTranslation("investigation");
  const theme = useTheme();

  return (
    <Box>
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12, lg: 7 }} sx={{ my: "auto" }}>
          <Typography
            variant="h4"
            color={theme.palette.pink.main}
            textAlign="center"
          >
            {title ?? t("advertisement.title")}
          </Typography>
          <Typography my={1} textAlign="center">
            {description ?? t("advertisement.description")}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12, lg: 5 }}>
          <img
            style={{ width: "100%", height: "150px" }}
            src={EthiquinNoData}
            alt="Nodata"
          />
        </Grid2>
      </Grid2>
    </Box>
  );
};
